import { styled } from '@mui/material/styles';

export const GoogleAuthNoticeContent = styled('div')(({ theme }) => ({
    minWidth: 480,
    padding: theme.spacing(1, 2, 3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        minWidth: 0,
        padding: theme.spacing(0, 0, 2),
    },
}));

export const GoogleAuthNoticeIllustration = styled('img')(({ theme }) => ({
    display: 'block',
    width: 320,
    maxWidth: '100%',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
        width: 250,
    },
}));

export const GoogleAuthNoticeActions = styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: 360,
    marginTop: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
}));
